import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fd89ceee"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_2 = {
  class: "previewer",
  style: {"background":"linear-gradient(transparent,#78E9E8 100%)"}
}
const _hoisted_3 = { class: "fixedpreview" }
const _hoisted_4 = { class: "fixedpreview2" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

import {reactive, ref} from "vue";
import {useStore} from "vuex";
import axios from "axios";
import request from "../../../api";
import DataUpload from "./DataUpload.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ShowInDetail',
  setup(__props) {

const store = useStore();
const listPage = ref(1), imageNumber = ref(16);
const fileList = ref([]), datasetInformation = ref({});
let selectList = Array(imageNumber.value).fill(0);
let deleteShow = ref(false);
const showList = ref([]), listPreview = ref([]);


refreshImages("getDatasetInfo");

async function refreshImages(option) {
  // console.log(option);
  await getDatasetInfos(option);
  updateShowList();
}

async function getDatasetInfos(option) {
  let requestUrl = "/dataset/" + option, requestData = {};
  requestData["datasetId"] = store.state.datasetId;
  await request.post(requestUrl, requestData)
      .then((res) => {
        console.log(res.data);
        if (res.status === 200) {
          // console.log(22222);
          let {datasetInfo, pictureDataInfos} = res.data.data;
          fileList.value = (pictureDataInfos);
          datasetInformation.value = (datasetInfo);
          // console.log(pictureDataInfos,datasetInfo)
          // console.log(fileList.value, datasetInformation.value);
        } else {
          console.log("err request");
        }
      })
      .catch((err) => {
        console.log(err);
      });
  // console.log(2212432, fileList);
}

const updateShowList = () => {
  showList.value = (fileList.value.slice((listPage.value - 1) * imageNumber.value,
      Math.min(fileList.value.length, listPage.value * imageNumber.value)));
  console.log("showList.value", showList.value);
  listPreview.value = (showList.value.map((e) => {
    return "http://" + e["pictureUrl"];
  }));
  // console.log("store.state.datasetId", store.state.datasetId)
  console.log("listPreview.value", listPreview.value)
};
const selectChange = (index) => {
  selectList[index] ^= 1;
  console.log(selectList);
};
function selectAll(){
  for(let i=0; i<imageNumber.value; i++){
    if(selectList[i] == 0){
      const checkbox = document.querySelector('#el-checkbox-'+i.toString());  // 获取 el-checkbox 对应的 input 元素
      checkbox.checked = true; // 修改复选框的选中状态
      checkbox.dispatchEvent(new Event('change')); // 触发 change 事件

      //
      // checkbox.addEventListener('change', (event) => {
      //   console.log(`复选框状态变化，当前选中状态为：${event.target.checked}`);
      // });
      // selectChange(i)
    }
  }
  console.log(selectList);
}
function selectNone(){
  for(let i=0; i<imageNumber.value; i++){
    if(selectList[i] == 1){
      const checkbox = document.querySelector('#el-checkbox-'+i.toString());  // 获取 el-checkbox 对应的 input 元素
      checkbox.checked = false; // 修改复选框的选中状态
      checkbox.dispatchEvent(new Event('change')); // 触发 change 事件
    }
  }
  console.log(selectList);
}
const deleteClick = () => {
  deleteShow.value = true;
  selectList = Array(imageNumber.value).fill(0);
};
const deleteCancel = () => {
  deleteShow.value = false;
  selectList.fill(0, 0, imageNumber.value);
};

async function deleteConfirm() {
  let deleteList = {"pictureids": []};
  for (let i in (selectList.reverse())) {
    const deleteIndex = imageNumber.value - 1 - parseInt(i);
    if (deleteIndex >= showList.value.length) continue;
    // console.log(i, deleteIndex);
    if (selectList[i] === 1) {
      console.log(deleteIndex, "delete", fileList.value);
      deleteList["pictureids"].push(fileList.value[deleteIndex].pictureId);
      fileList.value.splice(deleteIndex, 1);
    }
    // console.log(fileList);
  }
  await request.post("/data/deletepictures", deleteList)
      .then(res => {
        if (res.status === 200) {

        } else {
          console.log("err in delete image!");
        }
      })
      .catch(err => {
        console.log(err);
      });
  await refreshImages("getDatasetInfo");

  deleteShow.value = false;
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(DataUpload, {
      onUpdateFileList: _cache[0] || (_cache[0] = ($event: any) => (refreshImages('getDatasetInfo')))
    }),
    (_unref(deleteShow)===false)
      ? (_openBlock(), _createBlock(_component_el_button, {
          key: 0,
          type: "danger",
          onClick: deleteClick
        }, {
          default: _withCtx(() => [
            _createTextVNode("删除图片")
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_unref(deleteShow))
      ? (_openBlock(), _createBlock(_component_el_button, {
          key: 1,
          onClick: selectAll
        }, {
          default: _withCtx(() => [
            _createTextVNode("全选")
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_unref(deleteShow))
      ? (_openBlock(), _createBlock(_component_el_button, {
          key: 2,
          onClick: selectNone
        }, {
          default: _withCtx(() => [
            _createTextVNode("全部取消")
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_unref(deleteShow))
      ? (_openBlock(), _createBlock(_component_el_button, {
          key: 3,
          onClick: deleteConfirm
        }, {
          default: _withCtx(() => [
            _createTextVNode("确定")
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_unref(deleteShow))
      ? (_openBlock(), _createBlock(_component_el_button, {
          key: 4,
          onClick: deleteCancel
        }, {
          default: _withCtx(() => [
            _createTextVNode("取消")
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 6 }),
          _createVNode(_component_el_col, { span: 12 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_row, null, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(showList.value, (item, index) => {
                    return (_openBlock(), _createBlock(_component_el_col, { span: 6 }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_3, [
                          _createElementVNode("div", _hoisted_4, [
                            _createVNode(_component_el_image, {
                              src: `http://${item.pictureUrl}`,
                              "preview-src-list": listPreview.value,
                              "initial-index": index,
                              style: {"width":"100%","height":"100%"},
                              fit: 'fill'
                            }, null, 8, ["src", "preview-src-list", "initial-index"])
                          ])
                        ]),
                        _hoisted_5,
                        (_unref(deleteShow))
                          ? (_openBlock(), _createBlock(_component_el_checkbox, {
                              key: 0,
                              id: 'el-checkbox-'+index,
                              onChange: ($event: any) => (selectChange(index))
                            }, null, 8, ["id", "onChange"]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1024))
                  }), 256))
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 6 })
        ]),
        _: 1
      }),
      _createVNode(_component_el_pagination, {
        "current-page": listPage.value,
        "onUpdate:currentPage": _cache[1] || (_cache[1] = ($event: any) => ((listPage).value = $event)),
        "page-size": imageNumber.value,
        "pager-count": 7,
        layout: "prev, pager, next",
        total: Number(`${fileList.value.length}`),
        onCurrentChange: updateShowList,
        "hide-on-single-page": "",
        style: {"padding-left":"45%"}
      }, null, 8, ["current-page", "page-size", "total"])
    ])
  ], 64))
}
}

})